import type { SVGProps } from "react";

/**
 * The BOI brand signature arrow — an open arrowhead used as a trailing glyph on
 * primary CTAs and as the bullet for action lists. This is the exact brand
 * mark; do not swap it for the unicode arrow or a lucide icon.
 */
export function BrandArrow(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <line x1="4" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  );
}
